export default [
    { id: 'Lines', label: 'Lines', parent: '' },
    { id: 'PurchaseOrderDetails', label: 'Purchase Order Details', parent: '' },
    { id: 'Delivery', label: 'Delivery', parent: '' },
    { id: 'LineDetails', label: 'Line Details', parent: 'Lines' },
    { id: 'PurchaseOrdersDiary', label: 'Diary', parent: '' },
    { id: 'PurchaseOrdersDiaryDetails', label: 'Diary Details', parent: 'PurchaseOrdersDiary' },
    { id: 'PurchaseOrdersNotepad', label: 'Notepad', parent: '' },
    { id: 'Commit', label: 'Commit', parent: '' },
    { id: 'PurchaseOrderLineCommitments', label: 'Line Commitments', parent: 'Commit' },
];
